export enum ThemeType {
	Default = 'default',
	ThemeCreator1 = 'ThemeCreator1',
	ThemeCreator2 = 'ThemeCreator2'
}
